/* global axios */
import ApiClient from '../ApiClient';

// Prime Insight — reads the AI analysis for a conversation (Diferencial A).
// GET /api/v1/accounts/:account_id/conversations/:conversation_id/metrica_analysis
class MetricaAnalysisAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getForConversation(conversationId) {
    return axios.get(`${this.url}/${conversationId}/metrica_analysis`);
  }
}

export default new MetricaAnalysisAPI();
